import React from 'react';
import { ArrowRight } from 'lucide-react';
export function TransformationSection() {
  return <section className="w-full bg-[#FDFCF8] py-16 md:py-24 px-4" data-id="element-228">
      <div className="max-w-4xl mx-auto" data-id="element-229">
        <div className="bg-white p-8 md:p-16 rounded-3xl shadow-lg border border-stone-100 text-center" data-id="element-230">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-stone-900 mb-8" data-id="element-231">
            Qué cambia en 48 horas
          </h2>

          <p className="text-lg text-stone-600 mb-10" data-id="element-232">
            No te voy a prometer una vida perfecta. <br data-id="element-233" />
            Lo que sí cambia rápido es esto:
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 text-left max-w-2xl mx-auto mb-12" data-id="element-234">
            {['Dejás de buscar papeles', 'Dejás de repetir instrucciones', 'Dejás de explicar lo obvio', 'Bajan los olvidos tontos'].map((item, i) => <div key={i} className="flex items-center p-4 bg-stone-50 rounded-lg border border-stone-100" data-id="element-235">
                <ArrowRight className="w-5 h-5 text-emerald-600 mr-3 flex-shrink-0" data-id="element-236" />
                <span className="text-stone-800 font-medium" data-id="element-237">{item}</span>
              </div>)}
          </div>

          <div className="inline-block" data-id="element-238">
            <p className="text-xl md:text-2xl font-serif italic text-stone-800 mb-2" data-id="element-239">
              Y cuando aparece el orden, <br data-id="element-240" />
              algo se afloja por dentro.
            </p>
          </div>
        </div>
      </div>
    </section>;
}